import React, { useState } from "react";

const PersonalDataForm: React.FC<any> = ({ formData, updateForm, handleNext }) => {
  const [errorMessages, setErrorMessages] = useState<any>({});

  const validateField = (name: string, value: string) => {
    let error = "";

    switch (name) {
      case "firstName":
      case "lastName":
        if (!value.trim()) error = "Dieses Feld ist erforderlich.";
        break;
      case "email":
        if (!value.trim()) {
          error = "E-Mail ist erforderlich.";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = "Bitte geben Sie eine gültige E-Mail-Adresse ein.";
        }
        break;
      case "phone":
        if (!value.trim()) {
          error = "Telefonnummer ist erforderlich.";
        } else if (!/^\+?[0-9\s\-()]{7,15}$/.test(value)) {
          error = "Bitte geben Sie eine gültige Telefonnummer ein.";
        }
        break;
      case "address":
        if (!value.trim()) error = "Dieses Feld ist erforderlich.";
        break;
      default:
        break;
    }

    return error;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const errorMessage = validateField(name, value);

    setErrorMessages((prev: any) => ({
      ...prev,
      [name]: errorMessage,
    }));

    updateForm({ [name]: value });
  };

  const handleSubmit = () => {
    const fieldsToValidate = ["firstName", "lastName", "email", "phone", "address"];
    const newErrorMessages: any = {};

    fieldsToValidate.forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrorMessages[field] = error;
    });

    setErrorMessages(newErrorMessages);

    if (Object.keys(newErrorMessages).length > 0) return;

    handleNext();

    console.log("Form submitted:", formData);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="w-full bg-gray-100 p-4 rounded-3xl space-y-4">
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
          <div className="flex flex-col">
            <label htmlFor="firstName" className="text-sm font-medium mb-1">
              Vorname
            </label>
            <input
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              placeholder="Ihr Vorname"
              className={`p-2 bg-white rounded-2xl border ${errorMessages.firstName ? "border-red-600" : "border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-red-600`}
            />
            {errorMessages.firstName && (
              <span className="text-red-600 text-xs mt-1">
                {errorMessages.firstName}
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <label htmlFor="lastName" className="text-sm font-medium mb-1">
              Nachname
            </label>
            <input
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              placeholder="Ihr Nachname"
              className={`p-2 bg-white rounded-2xl border ${errorMessages.lastName ? "border-red-600" : "border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-red-600`}
            />
            {errorMessages.lastName && (
              <span className="text-red-600 text-xs mt-1">
                {errorMessages.lastName}
              </span>
            )}
          </div>
        </div>



        <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
          <div className="flex flex-col">
            <label htmlFor="email" className="text-sm font-medium mb-1">
              E-Mail
            </label>
            <input
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Ihre E-Mail-Adresse"
              className={`p-2 bg-white rounded-2xl border ${errorMessages.email ? "border-red-600" : "border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-red-600`}
            />
            {errorMessages.email && (
              <span className="text-red-600 text-xs mt-1">
                {errorMessages.email}
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <label htmlFor="phone" className="text-sm font-medium mb-1">
              Telefonnummer
            </label>
            <input
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Ihre Telefonnummer"
              className={`p-2 bg-white rounded-2xl border ${errorMessages.phone ? "border-red-600" : "border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-red-600`}
            />
            {errorMessages.phone && (
              <span className="text-red-600 text-xs mt-1">
                {errorMessages.phone}
              </span>
            )}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
          <div className="flex flex-1 flex-col">
            <label htmlFor="address" className="text-sm font-medium mb-1">
              Adresse
            </label>
            <input
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="Geben Sie Ihre Adresse ein"
              className={`p-2 bg-white rounded-2xl border ${errorMessages.address ? "border-red-600" : "border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-red-600`}
            />
            {errorMessages.address && (
              <span className="text-red-600 text-xs mt-1">
                {errorMessages.address}
              </span>
            )}
          </div>

        </div>


        <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
          <div className="flex flex-col">
            <label htmlFor="postalCode" className="text-sm font-medium mb-1">
              Postleitzahl
            </label>
            <input
              id="postalCode"
              name="postalCode"
              value={formData.postalCode}
              disabled={true}
              onChange={handleInputChange}
              placeholder="Ihre Postleitzahl"
              className={`p-2 bg-white rounded-2xl border ${errorMessages.postalCode ? "border-red-600" : "border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-red-600 bg-gray-300`}
            />
            {errorMessages.postalCode && (
              <span className="text-red-600 text-xs mt-1">
                {errorMessages.postalCode}
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <label htmlFor="phone" className="text-sm font-medium mb-1">
              Stadt
            </label>
            <input
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              placeholder="Deine Stadt"
              className={`p-2 bg-white rounded-2xl border ${errorMessages.city ? "border-red-600" : "border-gray-300"
                } focus:outline-none focus:ring-2 focus:ring-red-600`}
            />
            {errorMessages.city && (
              <span className="text-red-600 text-xs mt-1">
                {errorMessages.city}
              </span>
            )}
          </div>
        </div>


        <button
          onClick={handleSubmit}
          className="w-full bg-white text-black font-bold py-3 rounded-2xl border border-gray-300 hover:bg-gray-200 transition-colors"
        >
          Überprüfung Ihre Angaben <span className="text-red-600 ml-2">&gt;</span>
        </button>
      </div>
    </div>
  );
};

export default PersonalDataForm;
